import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["roleInput", "branch"]
  static classes = ["hidden"]
  static values = { locked: Boolean, role: String }

  connect() {
    if (this.lockedValue) {
      this.roleInputTargets.forEach((input) => {
        input.checked = input.value === this.roleValue
        input.disabled = true
      })
    }

    this.syncBranches()
  }

  roleChanged() {
    this.syncBranches()
  }

  syncBranches() {
    const role = this.selectedRole

    this.branchTargets.forEach((branch) => {
      const visible = branch.dataset.roleFieldsRole === role

      branch.classList.toggle(this.hiddenClass, !visible)
      branch.querySelectorAll("input, select, textarea, button").forEach((input) => {
        input.disabled = !visible
      })
    })
  }

  get selectedRole() {
    if (this.lockedValue) return this.roleValue

    return this.roleInputTargets.find((input) => input.checked)?.value || "spectator"
  }
}
